import { cashierAxios } from "../axiosInstance";
import { notify } from "../components/toastify";
import { useNavigate } from "react-router";
import { isNetworkError } from "./offline/storage";
import { loadRead, saveRead, searchCachedProducts } from "./offline/readCache";

// A request that never reached the server: no toast, callers fall back to
// the offline path.
const offlineError = () => {
  const e = new Error("You are offline");
  e.isNetworkError = true;
  return e;
};

// let hasNotified = false;
const CashierApi = () => {
  const navigate = useNavigate();
  const fetchData = async (endpoint, page = 1, search = "") => {
    try {
      let url = `${endpoint}?page=${page}`;
      if (search) {
        url += `&searchParam=${search}`; // Correctly append search parameter
      }

      const response = await cashierAxios.post(url, {});
      // console.log(response.data.data);
      saveRead(url, response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      if (isNetworkError(error)) {
        const cached =
          loadRead(`${endpoint}?page=${page}${search ? `&searchParam=${search}` : ""}`) ??
          (endpoint === "products" ? searchCachedProducts(search) : undefined);
        if (cached !== undefined) return cached;
        throw offlineError();
      }
      // if (!hasNotified) {
      if (error.response?.status === 401 || error?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);

      throw new Error(error.response?.data?.message || error.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };

  const fetchOnlyData = async (endpoint) => {
    try {
      let url = `${endpoint}`;

      const response = await cashierAxios.get(url);
      saveRead(url, response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      if (isNetworkError(error)) {
        const cached = loadRead(endpoint);
        if (cached !== undefined) return cached;
        throw offlineError();
      }
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);
      throw new Error(error.response?.data?.message || error?.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };
  const fetchPinData = async (endpoint) => {
    try {
      let url = `${endpoint}`;

      const response = await cashierAxios.get(url, {});
      notify(response?.data?.message, "success");
      return response;
    } catch (error) {
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error?.message);

      console.log(error?.message);
      throw new Error(error?.response?.data?.message || error?.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };

  const createData = async (endpoint, data, showNotification) => {
    try {
      const response = await cashierAxios.post(`${endpoint}`, data);
      if (showNotification) {
      } else {
        notify(response?.data?.message, "success");
      }

      return response?.data; // Adjust based on the structure of your response
    } catch (error) {
      if (isNetworkError(error)) throw offlineError();
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  const updateData = async (endpoint, id, data, showNotification) => {
    try {
      const response = await cashierAxios.put(`${endpoint}${id}`, data);
      if (showNotification) {
      } else {
        notify(response?.data?.message, "success");
      }
      return response?.data;
      // Adjust based on the structure of your response
    } catch (error) {
      if (isNetworkError(error)) throw offlineError();
      if (error?.response?.status === 401 || error.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error?.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  const deleteData = async (endpoint, id) => {
    try {
      const response = await cashierAxios.delete(`${endpoint}${id}`);
      notify(response?.data?.message, "success");
      return response?.data; // Adjust based on the structure of your response
    } catch (error) {
      if (isNetworkError(error)) throw offlineError();
      notify(error?.response?.data?.message || error.message);
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }

      throw new Error(error.response.status);
    }
  };

  const getDataById = async (endpoint, id) => {
    try {
      const response = await cashierAxios.get(`${endpoint}${id}`);
      // notify(response.data.message);
      saveRead(`${endpoint}${id}`, response?.data);
      return response; // Adjust based on the structure of your response
    } catch (error) {
      if (isNetworkError(error)) {
        const cached = loadRead(`${endpoint}${id}`);
        if (cached !== undefined) return { data: cached };
        throw offlineError();
      }
      notify(error?.response?.data?.message || error.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  return {
    fetchData,
    fetchOnlyData,
    fetchPinData,
    createData,
    updateData,
    deleteData,
    getDataById,
  };
};

export default CashierApi;
